<div class="explorer-header row">
  <div class="col-12 d-flex">
    <a (click)="pathChange.emit(path.removeLast())" class="mx-2" style="cursor: pointer">
      <fa-icon icon="arrow-circle-up" size="2x"></fa-icon>
    </a>
    <input class="form-control" type="text" [value]="'/' + path.removeFirst().get().join('/')" aria-label="Path" readonly />
  </div>
  <div class="col-12 my-2">
    <app-type-filter [(typesFilter)]="typesFilter" (filters)="updateFilters($event)"></app-type-filter>
  </div>
  <div class="col-12 my-2">
    <app-file-upload
      [(uploadProgress)]="uploadProgress"
      [(uploading)]="uploading"
      [disabled]="!canUpload"
      (upload)="upload($event)"
      [fileTypes]="fileTypes"
      [confirm]="true"
    ></app-file-upload>
  </div>
</div>

<div class="row">
  <div class="col-9 explorer" (window:keyup.control)="multi = false;" (window:keydown.control)="multi = true;">
    <div *ngIf="loading" class="text-center">
      <div class="spinner-border spinner-border-lg"></div>
    </div>
    <div *ngIf="!loading" class="file-container" infiniteScroll [infiniteScrollDistance]="2" [scrollWindow]="false" (scrolled)="onScroll()">
      <div *ngFor="let f of files">
        <div
          class="element border rounded"
          *ngIf="typesFilter.length == 0 || typesFilter.includes(f.type)"
          (click)="onFile(f)"
          [ngClass]="{'selected': isSelected(f)}"
        >
          <div
            class="head"
            *ngIf="f.type === 'image' && (image.url(f.path) | async); let img; else iconPlaceholder"
            [ngStyle]="{'background-image': 'url(' + img + ')'}"
          ></div>
          <ng-template #iconPlaceholder>
            <div class="head">
              <fa-icon [icon]="f.icon" class="mx-auto" size="6x" [fixedWidth]="true"></fa-icon>
            </div>
          </ng-template>
          <div class="body">{{f.basename}}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-3">
    <div class="explorer-preview">
      <h5>Preview</h5>

      <div class="head mx-auto my-4" *ngIf="select.length === 1">
        <img *ngIf="select[0].type === 'image'" [attr.src]="image.url(select[0].path) | async" />
        <video *ngIf="select[0].type === 'video'" [attr.src]="image.url(select[0].path) | async" controls></video>
        <audio *ngIf="select[0].type === 'audio'" [attr.src]="image.url(select[0].path) | async" controls></audio>
        <fa-icon *ngIf="select[0].type === 'document'" [icon]="select[0].icon" size="6x" [fixedWidth]="true"></fa-icon>
      </div>
      <div class="head mx-auto my-4" *ngIf="select.length !== 1">
        <fa-icon icon="copy" size="6x" [fixedWidth]="true"></fa-icon>
      </div>

      <div class="text">{{ selectedText }}</div>

      <div class="btn-group mt-2 w-60" role="group" *ngIf="select.length">
        <button *ngIf="select.length === 1" class="btn btn-success" (click)="download(select)">Open</button>
        <button [disabled]="!canDelete" class="btn btn-danger" (click)="delete(select)">Delete</button>
      </div>
    </div>
  </div>
</div>
